<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          Credits
        </CCardHeader>
        <CCardBody>
          <loading :active.sync="isLoading"
          :can-cancel="false"
          :on-cancel="onCancel"
          :is-full-page="fullPage"></loading>
          <v-client-table v-bind:data="resources" v-bind:columns="columns" :options="options" id="dataTable" class="resource-list">
            <span slot="username" @click="redirectUserDetails('/users-details/'+props.row.userid)" slot-scope="props" class="display-link userLink"> {{props.row.username}} </span>
            <span slot="price" slot-scope="props" class="display-link"> {{props.row.currency}} {{props.row.price}} </span>
            <span slot="status" slot-scope="props" class="display-link">{{props.row.status}}</span>
            <span slot="devicetype" slot-scope="props" class="display-link">{{props.row.devicetype}}</span>
            <!-- <span slot="transactionDate" slot-scope="props">{{ moment(props.row.createdAt).format('YYYY-MM-D, h:mm:ss a') }} </span> -->
            <span slot="transactionDate" slot-scope="props">{{ props.row.createdAt | momentDate }} </span>
            <span slot="name" slot-scope="props" class="display-link"> {{props.row._id}} </span>
            <span slot="action" slot-scope="props">
              <div class="row">
                <div class="col">
                  <button slot="name" class="display-link userLink" @click="redirectUrls('/advert-details/'+props.row._id)" data-toggle="tooltip" data-placement="top" title="View"><img class="view-details" src="download.png" /></button>
                </div>
              </div>
            </span>
          </v-client-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import VueNotifications from 'vue-notifications'

import Datepicker from 'vuejs-datepicker';
// Import component
import Loading from 'vue-loading-overlay';
import moment from 'moment'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
const {
    email,
    required,
    maxLength,
	minLength,
	sameAs
} = require("vuelidate/lib/validators");
export default {
    name: 'creditList',
    data() {
        return {
            showAddBtn: true,
            dateselection: {
              datefrom: "",
              dateto: ""
            },
            format: 'yyyy-MM-dd',
            isLoading: false,
            fullPage: true,
            API_URL: API_URL,
            APP_URL: APP_URL,
            resources: [],
            columns: ['username', 'transactionId', 'price', 'status', 'transactionDate', 'devicetype', 'credit'],
            activeOptions: [{id: 0, text: 'Deactive'}, {id: 1, text: 'Active'}],
            selectedOption: '0',
            token: localStorage.getItem('token'),
            tokenChange: JSON.parse(localStorage.getItem('token')),
            options: {
              headings: {
                username: 'User Name',
                transactionId: 'Transaction Id',
                amountpaid: 'Amount Paid',
                credit: 'Credit',
                status: 'Transaction Status',
                transactionDate: 'Transaction Date',
                devicetype: 'Device Type'
              },
              sortable: ['firstname'],
              sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              pagination: {
                chunk: 5,
                edge: false,
                nav: 'scroll'
              },
              texts:{
                filterPlaceholder:"Search",
                filter:"Search",
                count: "Showing {from} to {to} of {count} records"
                // count: "Showing {from} to {to} of {count} records|{count} records|One record"
              },
            }
        }
    },
    components: {
        Loading,
        Datepicker
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    created() {
        document.title = "Credit list";
        this.loadData();
    },
    methods: {
        loadData() {
            this.showLoader();
            this.isLoading = true;
            axios.post(`${API_ADMIN_URL}/adminCreditHistory`, {}, {headers: {'x-access-token': this.tokenChange}}).then(response => {
                if (response.data.status == 200) {
                    this.resources = response.data.data;
                    this.isLoading = false;
                } else {
                    localStorage.clear();
                    this.$router.push('/login');
                }
              this.hideLoader();
            });
        },
        moment: function (date) {
          return moment(date);
        },
      onCancel() {
      },
      showLoader: function() {
          this.$isLoading = true;
          this.$emit('loading', true);
      },
      hideLoader: function() {
          this.$isLoading = false;
          this.$emit('loading', false);
      },
      redirectUrls: function(link) {
        // alert(link);
          this.$router.push(link);
      },
      redirectUserDetails: function(link) {
        //this.$router.push(link);
        window.open(link, '_blank');
      },
    },
    mixins: [validationMixin],
    validations: {
      dateselection:{
        datefrom: {
                  required,
              },
        dateto: {
                  required,
              }
      }
    }
}
</script>
